import React from 'react'
import StudentInstruction from '../../Components/StudentInstruction'

export default React.memo(function ASRTeacherModeView(props) {

    const { teacherMode } = props

    if(!teacherMode) return null

    return (
        <StudentInstruction>
            <h2>Teacher please say, "I'm ready to start"</h2>
        </StudentInstruction>
    )
})